import React from "react";
import { LogOut, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Piccolo box informativo: numero di ospiti fuori struttura (usciti/ricoverati) + nomi in piccolo.
// Cliccando porta alla categoria Entrate / Uscite (/movimenti).
export const isFuori = (r) => ["ospedale", "uscita"].includes(r?.presenza);
export const fuoriLabel = (r) => (r?.presenza === "ospedale" ? "Ricoverato" : "Uscito");
// Dimesso SOLO se la data di dimissione è già arrivata (<= oggi). Una dimissione futura
// NON nasconde l'ospite: resta presente/ricoverato finché non scatta la data.
const _today10 = () => { const x = new Date(); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`; };
export const isDimesso = (r) => { const d = r?.data_dimissione ? String(r.data_dimissione).trim().slice(0, 10) : ""; return !!d && d <= _today10(); };

export const UscitiInfoBox = ({ usciti = [], testid = "usciti-info-box" }) => {
  const navigate = useNavigate();
  if (!usciti.length) return null;
  const nf = usciti.filter((u) => u.presenza === "uscita");
  const ric = usciti.filter((u) => u.presenza === "ospedale");
  return (
    <button
      type="button"
      onClick={() => navigate("/movimenti")}
      title="Vai a Entrate / Uscite"
      className="w-full text-left rounded-xl border-2 border-amber-200 bg-amber-50 px-3 py-2 mb-4 hover:bg-amber-100 hover:border-amber-300 transition-colors cursor-pointer"
      data-testid={testid}
    >
      <div className="flex items-center gap-2 flex-wrap text-sm">
        <LogOut size={15} className="text-amber-700 shrink-0" />
        <span className="font-bold text-amber-800" data-testid={`${testid}-count`}>{usciti.length} fuori struttura</span>
        {nf.length > 0 && <span className="text-xs font-semibold text-amber-700">· {nf.length} {nf.length === 1 ? "uscito" : "usciti"}</span>}
        {ric.length > 0 && <span className="text-xs font-semibold text-red-700">· {ric.length} {ric.length === 1 ? "ricoverato" : "ricoverati"}</span>}
        <span className="text-[11px] text-amber-700/70 font-normal">(non conteggiati nelle statistiche)</span>
        <span className="ml-auto inline-flex items-center gap-0.5 text-[11px] font-semibold text-amber-700">Entrate / Uscite <ChevronRight size={13} /></span>
      </div>
      <div className="text-[11px] text-amber-800/80 mt-0.5 leading-snug" data-testid={`${testid}-names`}>
        {usciti.map((u, i) => (
          <span key={i}>{i > 0 ? ", " : ""}<b>{[u.cognome, u.nome].filter(Boolean).join(" ")}</b> <span className="text-[10px]">({u.presenza === "ospedale" ? "ricoverato" : "uscito"})</span></span>
        ))}
      </div>
    </button>
  );
};

export default UscitiInfoBox;
